import { FOUR_SECONDS_IN_MS } from 'constants/timers';
import { useEmbeddedProps } from 'hooks/useEmbeddedProps/useEmbeddedProps';
import { useFieldValues } from 'hooks/useFieldValues/useFieldValues';
import { Success as SuccessIcon } from 'icons';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { RedirectUrl, useTranslations } from 'utils';
import './Success.scss';

type SucccessProps = {
  paymentId: string;
  status: string;
  redirectionTimeout?: number;
};

export const Success = ({
  paymentId,
  status,
  redirectionTimeout = FOUR_SECONDS_IN_MS,
}: PropsWithChildren<SucccessProps>) => {
  const { return_url: returnUrl } = useFieldValues();

  const { fwFinish } = useEmbeddedProps();
  const i18n = useTranslations();

  const shouldRedirect = returnUrl && fwFinish;
  const redirectUrl =
    shouldRedirect && RedirectUrl.build(returnUrl, paymentId, status);

  useEffect(() => {
    const timer = setInterval(() => {
      if (shouldRedirect) {
        fwFinish(redirectUrl);
      }
    }, redirectionTimeout);

    return () => {
      timer && clearInterval(timer);
    };
  }, [fwFinish, redirectUrl, redirectionTimeout, shouldRedirect]);

  return (
    <div className="CardSurchargeSuccess">
      <div className="CardSurchargeSuccess-Content">
        <SuccessIcon width={64} height={64} />
        <h5>{i18n.t('cardForm.success.title')}</h5>
        {shouldRedirect && <p>{i18n.t('cardForm.success.message')}...</p>}
      </div>
    </div>
  );
};
